import { useState } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import { Button } from "components/core/basic/Button";
import { useAddProductsToPlan } from "../api/useAddProductsToPlan";

const PricingPlanChoice = ({ plans, setIsOpen, isOpen, productById, selectedProducts, setSelectedProducts }) => {
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const addProductsMutation = useAddProductsToPlan();

  const addProductsToPlan = async (plan_id) => {
    addProductsMutation.mutate(
      { plan_id, product_ids: selectedProducts },
      {
        onSuccess: () => {
          setSelectedProducts([]);
          document.location.reload();
        },
      },
    );
  };

  const selectedPlan = plans?.find((plan) => plan.id === selectedPlanId);

  if (!isOpen) {
    return <span></span>;
  }

  return (
    <Modal show={isOpen} size="lg">
      <Modal.Header className="py-0 px-5">
        <Row style={{ width: "100%" }}>
          <Col md={6}>
            <div className="fs-3 my-4 text-start">Add Product to Existing Plan</div>
          </Col>
          <Col md={6} className="text-end"></Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row className="py-2">
          {showConfirmation && (
            <Col md={{ span: 8, offset: 2 }}>
              <div className=" my-4 text-center fs-4 fw-bold">
                <div>The products are being added to: {selectedPlan.plan_name}</div>
              </div>
            </Col>
          )}
          {!showConfirmation && (
            <Col md={{ span: 8, offset: 2 }}>
              <div className="fs-3 my-4 text-center">
                <div>Choose the Pricing Plan to add these products into</div>
                <small>
                  {selectedProducts.slice(0, 5).map((id, i) => (
                    <span key={i} className="pe-3">
                      {productById[id].sku}
                    </span>
                  ))}
                  {selectedProducts.length > 5 && <span> plus {selectedProducts.length - 5} more</span>}
                </small>
              </div>

              <Row className="fs-4 text-start pt-1 pb-3">
                <Col>
                  <Row className="pb-2">
                    <Col xs={1}>&nbsp;</Col>
                    <Col>
                      <span className="fw-bold">Plan Name</span>
                    </Col>
                  </Row>
                  {plans?.map((plan, i) => (
                    <Row className="pb-2" key={i}>
                      <Col xs={1}>
                        <input
                          type="checkbox"
                          checked={selectedPlanId === plan.id}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedPlanId(plan.id);
                            } else {
                              setSelectedPlanId(null);
                            }
                          }}
                        />
                      </Col>
                      <Col>{plan.plan_name}</Col>
                    </Row>
                  ))}
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row style={{ width: "100%" }}>
          <Col xs={3}>&nbsp;</Col>
          <Col xs={3} className="mx-auto text-center">
            <Button
              onPress={() => {
                setIsOpen(false);
              }}
            >{`Close`}</Button>
          </Col>
          <Col xs={3} className="mx-auto text-center">
            <Button
              onPress={() => {
                if (showConfirmation) {
                  addProductsToPlan(selectedPlanId);
                } else {
                  setShowConfirmation(true);
                }
              }}
              isDisabled={!selectedPlanId}
            >
              {"Add to Plan"}
            </Button>
          </Col>
          <Col xs={3}>&nbsp;</Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default PricingPlanChoice;
